export default {
  text_one: 'Ganhe {{count}} ponto',
  text_other: 'Ganhe {{count}} pontos',
};
